module.exports = __webpack_public_path__ + "images/icons_v2/location-baseline-outlined-eb809aeb.svg";